import {recalc} from '@/app/js/handle-payment-counters'

export function handleAutoCreditingFancy() {
  const btnEl = document.querySelector('.js-auto-crediting-fancy')

  if (!btnEl) return

  btnEl.addEventListener('click', () => {
    const fancyEl = document.querySelector(btnEl.dataset.src)
    const calcEl = document.getElementById('vueLendingCalculator')

    fancyEl.querySelector('.js-payment-counter-car-cost').value = calcEl.querySelector('.js-landing-calculator-car-cost').value
    fancyEl.querySelector('.js-payment-counter-first-payment').value = calcEl.querySelector('.js-landing-calculator-first-payment').value
    fancyEl.querySelector('.js-payment-counter-term').value = calcEl.querySelector('.js-landing-calculator-term').value

    recalc()

    $.fancybox.open({
      src: btnEl.dataset.src
    })
  })
}
